import React, { useState } from 'react'
import {
  CaretDown,
  DotsThreeOutline,
  FolderOpen,
  BookOpen,
  Gear,
  Layout,
  MagnifyingGlass,
  SignOut,
  X,
  User,
} from '@phosphor-icons/react'
import ProgressUsage from './ProgressUsage'

const ApplicationHeader = ({
  dashboard_path,
  search_path,
  projects_path,
  settings_path,
  session_path,
  authenticated,
  user,
  logo_path,
}) => {
  const [searchQuery, setSearchQuery] = useState('')
  const [searchResults, setSearchResults] = useState([])
  const [showResults, setShowResults] = useState(false)

  const handleSearch = () => {
    if (searchQuery.length >= 3) {
      fetch(search_path, {
        method: 'POST',
        headers: {
          'X-CSRF-Token': document.querySelector("meta[name='csrf-token']").content,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ query: searchQuery }),
      }).then(response => response.json())
        .then(data => {
          setSearchResults(data.search_result)
          setShowResults(true)
        })
    }
  }

  const handleClear = () => {
    setSearchQuery('')
    setSearchResults([])
    setShowResults(false)
  }

  const handleSignOut = () => {
    fetch(session_path, {
      method: 'DELETE',
      headers: {
        'X-CSRF-Token': document.querySelector("meta[name='csrf-token']").content,
        'Content-Type': 'application/json',

      }
    }).then(() => {
      Turbo.visit('/session/new')
    });
  }


  return (
    <div
      className="navbar bg-base-100 fixed top-0 z-50 shadow-lg border-b border-info h-12">
      <div className="w-full px-0">
        <div className="mr-1">
          <a href={dashboard_path}>
            <div className="flex items-center gap-2">
              {logo_path &&
                <img src={logo_path} alt="neuropink" className="h-6"/>}
            </div>
          </a>
        </div>
        <div className="flex-1 p-0.5 flex items-center gap-1 relative">
          <input 
            type="text" 
            placeholder="Search" 
            className={`input input-sm w-full input-bordered ${searchQuery.length > 0 ? 'border-secondary' : ''}`} 
            value={searchQuery} 
            onChange={(e) => setSearchQuery(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && searchQuery.length >= 3 && handleSearch()}
          />
          <button 
            disabled={searchQuery.length < 3}
            className="btn btn-ghost btn-outline btn-xs" 
            onClick={showResults ? handleClear : handleSearch}
          >
            {showResults ? <X size={14}/> : <MagnifyingGlass size={14}/>}
          </button>

          {/* Search Results Dropdown */}
          {showResults && searchResults.length > 0 && (
            <div className="absolute top-full left-0 right-0 mt-1 bg-base-100 rounded-box shadow-xl border border-base-300 overflow-hidden">
              <ul className="menu menu-compact p-1">
                {searchResults.map((result) => (
                  <li key={result.id}>
                    <a 
                      href={result.url}
                      className="flex items-center gap-2 py-2 px-3 hover:bg-base-200 active:bg-base-300 transition-colors"
                    >
                      <div className="flex-none">
                        {result.type === "content" && <BookOpen size={16} className="text-primary" />}
                        {result.type === "project" && <FolderOpen size={16} className="text-secondary" />}
                      </div>
                      <div className="flex flex-col">
                        <span className="font-medium text-sm">{result.title}</span>
                        <span className="text-xs text-base-content/60 capitalize">{result.type}</span>
                      </div>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
        {/* Usage Progress Bar */}
        <ProgressUsage max_actions_per_month={user.max_actions_per_month}
                       total_actions_used={user.total_actions_used}/>

        <div className="flex-none">
          <div className="dropdown dropdown-end">
            <div tabIndex="0" role="button"
                 className="btn btn-ghost btn-xs border shadow-sm btn-outline mb-0.5">
              {authenticated ? (
                <>
                  <User size={14}/>
                  <span className="mx-1 text-xs">{user.email_address}</span>
                  <CaretDown size={14}/>
                </>
              ) : (
                <>
                  <DotsThreeOutline size={14}/>
                  <span className="mx-1 text-xs">Menu</span>
                  <CaretDown size={14}/>
                </>
              )}
            </div>
            <ul tabIndex="0"
                className="dropdown-content z-[50] menu p-1 shadow-lg bg-base-100 rounded-box w-48 border">
              <li>
                <a href={dashboard_path}
                   className="flex items-center gap-2 py-1 px-2">
                  <Layout size={14} className="text-primary"/>
                  <span className="text-xs">Dashboard</span>
                </a>
              </li>
              <li>
                <a href={projects_path}
                   className="flex items-center gap-2 py-1 px-2">
                  <FolderOpen size={14} className="text-secondary"/>
                  <span className="text-xs">Projects</span>
                </a>
              </li>
              <li>
                <a href={settings_path}
                   className="flex items-center gap-2 py-1 px-2">
                  <Gear size={14} className="text-info"/>
                  <span className="text-xs">Settings</span>
                </a>
              </li>
              <div className="divider -mb-2"></div>
              <li className="border-t border-secondary">
                <button onClick={handleSignOut}
                        className="w-full flex items-center gap-2 text-error">
                  <SignOut size={14} className="text-error"/>
                  <span className="text-xs">Sign out</span>
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ApplicationHeader
